import ErrorAlert from './error-alert';
export default ErrorAlert;
